import * as Sentry from '@sentry/react'

import { IResult, IData, Status } from './exceptionHelper'

export interface IFetchConfig {
  url: string
  arguments: {
    method: string
    headers?: Record<string, string>
    body?: string
  }
}

type TError = Error | IResult<IData> | IData

interface ICaptureFetchException {
  (err: TError, config: IFetchConfig | null): void
}

function isIResult(err: TError): err is IResult<IData> {
  return (
    err !== null &&
    (<IResult<IData>>err).code !== undefined &&
    (<IResult<IData>>err).data !== undefined
  )
}

function isIData(err: TError): err is IData {
  return err !== null && (<IData>err).status !== undefined
}

export const captureFetchException: ICaptureFetchException = (err, config) => {
  if (
    (isIResult(err) && (err.data === null || err.data === undefined)) || //接口返回数据结构不完整
    (isIResult(err) && Status[err.data.status] === undefined) ||
    (isIData(err) && Status[err.status] === undefined) || //reject接口返回result或result.data
    err instanceof Error //其他错误
  ) {
    Sentry.captureException(err, (scope) => {
      scope.setContext('fetch context', {
        'Error String': String(err),
        'Error Object': JSON.stringify(err),
        'Fetch URL': config ? config.url : '',
        'Fetch Body': config ? config.arguments.body : ''
      })
      scope.setTransactionName('Captured Fetch Exception')
      return scope
    })
  } else {
    console.log('reject null')
  }
  throw err
  // if (isIResult(err) && Status[err.data.status] === undefined || isIData(err) && Status[err.status] === undefined) {   //reject服务端返回result或result.data
  //   Sentry.captureException(err, (scope) => {
  //     scope.setContext("fetch context", {
  //       'Error String': String(err),
  //       'Error Object': JSON.stringify(err),
  //       'Fetch URL': config.url,
  //       'Fetch Body': config.arguments.body
  //     })
  //     scope.setTransactionName('Captured Fetch Exception')
  //     return scope
  //   })
  // } else if (err instanceof Error) {  //其他错误
  //   Sentry.captureException(err, (scope) => {
  //     scope.setContext("fetch context", {
  //       'Error String': String(err),
  //       'Error Object': JSON.stringify(err),
  //       'Fetch URL': config.url,
  //       'Fetch Body': config.arguments.body
  //     })
  //     scope.setTransactionName('Captured Fetch Exception')
  //     return scope
  //   })
  // }
}

interface CapturePromiseException {
  (err: TError | any): void
}

export const capturePromiseException: CapturePromiseException = (err) => {
  if (err === null || err === undefined) {
    return null
  }
  if (
    (isIResult(err) && Status[err?.data?.status] === undefined) ||
    (isIData(err) && Status[err?.status] === undefined)
  ) {
    //reject服务端返回result或result.data
    Sentry.captureException(err, (scope) => {
      scope.setContext('fetch context', {
        'Error String': String(err),
        'Error Object': JSON.stringify(err)
      })
      scope.setTransactionName('Captured Fetch Exception')
      return scope
    })
  } else if (err instanceof Error) {
    //其他错误
    Sentry.captureException(err, (scope) => {
      scope.setContext('fetch context', {
        'Error String': String(err),
        'Error Object': JSON.stringify(err)
      })
      scope.setTransactionName('Captured Fetch Exception')
      return scope
    })
    throw err
  }
}
